import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.linkTreeList = [];
};

const linkTreeListSuccess = (state, linkTreeList) => {
  state.linkTreeList = linkTreeList;
};

const createLinkTreeSuccess = (state, payload) => {
  state.linkTreeList.push(payload);
};

const editLinkTreeListSuccess = (state, payload) => {
  const foundIndex = state.linkTreeList.findIndex((linkTree) => linkTree.guid === payload.guid);
  state.linkTreeList[foundIndex] = payload;
};

const removeLinkTreeListSuccess = (state, payload) => {
  state.linkTreeList = state.linkTreeList.filter(((linkTree) => linkTree.guid !== payload.guid));
};

export const mutations = {
  [MutationTypes.LINK_TREE_LIST_SUCCESS]: linkTreeListSuccess,
  [MutationTypes.CREATE_LINK_TREE_SUCCESS]: createLinkTreeSuccess,
  [MutationTypes.EDIT_LINK_TREE_SUCCESS]: editLinkTreeListSuccess,
  [MutationTypes.DELETE_LINK_TREE_SUCCESS]: removeLinkTreeListSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
